import { render } from "./TestReportSkin.vue?vue&type=template&id=89ef1e0e&scoped=true&ts=true"
import script from "./TestReportSkin.vue?vue&type=script&lang=ts"
export * from "./TestReportSkin.vue?vue&type=script&lang=ts"

import "./TestReportSkin.vue?vue&type=style&index=0&id=89ef1e0e&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ef1e0e"]])

export default __exports__